<div ngbDropdown class="dropdown dropdown-icon-right w-100" #dropdown [placement]="placementDropDown()">
  <button class="dropdown-toggle form-control d-flex text-start align-items-center bg-white p-3" ngbDropdownToggle>
    <div class="w-100 flex-fill d-flex align-items-center">
      <span class="text-truncate d-inline-block flex-fill">
        {{ currentItemSelected()?.label ?? placeHolder() | translate }}
      </span>
    </div>
  </button>
  <div ngbDropdownMenu class="rounded-1 p-2 shadow dropdown-menu w-100">
    @for(item of itemsForSelect(); track item.id){
    <div ngbDropdownItem (click)="select(item)" class="cursor-pointer">{{ item.label | translate }}</div>
    }
  </div>
</div>
